// @ts-nocheck
import { gql } from "@apollo/client";
import { HgProduct } from "../../types/taxonomy";

export const INTENSITY_OVER_TIME_QUERY = gql`
  query intensityOverTime($hgId: Identifier!, $productIds: [Int]) {
    intensityOverTime(hgId: $hgId, productIds: $productIds) {
      productName
      trend {
        month
        quarter
        score
        year
      }
    }
  }
`;

export const INTENSITY_TREND_QUERY = gql`
  query intensityTrend($hgId: Identifier!, $page: Int, $per: Int) {
    intensityTrend(hgId: $hgId, page: $page, per: $per) {
      count
      data {
        productName
        value
        vendorUrl
      }
    }
  }
`;

export const INTENSITY_MOMENTUM_QUERY = gql`
  query intensityMomentum($hgId: Identifier!, $page: Int, $per: Int) {
    intensityMomentum(hgId: $hgId, page: $page, per: $per) {
      count
      data {
        productName
        value
        vendorUrl
      }
    }
  }
`;

export interface IntensityTrend {
  product?: ProductTrend;
  trend?: ProductIntensity;
}

export interface ProductTrend extends HgProduct {
  intensityMomentum?: number;
  intensityTrend?: number;
  intensity?: number;
  date?: Date;
}

export interface ProductIntensity {
  month: number;
  quarter: number;
  year: number;
  score: number;
}

export interface IntensityProductData {
  productName: string;
  value: number;
  vendorUrl: string;
}

export interface IntensityMomentumPayload {
  intensityMomentum: {
    data: Array<IntensityProductData>;
    count: number;
  };
}

export interface IntensityTrendPayload {
  intensityTrend: {
    data: Array<IntensityProductData>;
    count: number;
  };
}
export interface IntensityOverTimeData {
  productName: string;
  trend: {
    month: number;
    quarter: number;
    score: number;
    year: number;
  };
}

export interface IntensityOverTimePayload {
  intensityOverTime: Array<IntensityOverTimeData>;
}
